<template>
  <div>
    <div v-if="isDivider" class="divider_vertical" />

    <h1 v-else-if="isFirstElement" class="subtitle-1">
      <a-link :to="generatedLink" class="categories-strip__item-text">
        {{ prop('Name', item) }}
      </a-link>
    </h1>

    <h2 v-else>
      <a-link :to="generatedLink" class="categories-strip__item-text">
        {{ prop('Name', item) }}
      </a-link>
    </h2>
  </div>
</template>

<script>
import { prop, pathEq } from 'ramda'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { CATEGORY_STRIP_ITEM_TYPE } from 'shared/ACategoriesStrip/index'
import { ROUTE_NAME } from 'enums/routes'
import { SPECIAL_SUBCATEGORY } from 'enums/special-categories'

export default {
  name: 'CategoriesStripItem',
  props: {
    item: propValidator([PROP_TYPES.OBJECT, PROP_TYPES.STRING]),
    itemIndex: propValidator([PROP_TYPES.NUMBER]),
    thoughtLeaderShipRoute: propValidator([PROP_TYPES.OBJECT]),
    link: propValidator([PROP_TYPES.OBJECT], false)
  },
  computed: {
    isFirstElement() {
      return this.itemIndex === 0
    },
    isDivider() {
      return this.item.Type === CATEGORY_STRIP_ITEM_TYPE.DIVIDER
    },
    isEducationCenterSubcategory() {
      return pathEq(
        ['params', 'subcategory'],
        SPECIAL_SUBCATEGORY.EDUCATION_CENTER,
        this.link
      )
    },
    generatedLink() {
      return this.isEducationCenterSubcategory
        ? { name: ROUTE_NAME.CATEGORY_EDUCATION_CENTER }
        : this.link
    }
  },
  methods: {
    prop
  }
}
</script>

<style lang="scss" scoped></style>
